<template>
  <div class="app-container">
    <basic-container>
      <el-form label-width="80px" :rules="rules" ref="goodsForm" :model="goodsForm" size="medium" class="goods-form">
        <el-form-item label="商品名称" prop="name">
          <el-col :span="15">
            <el-input type="text" placeholder="请输入商品名称" v-model="goodsForm.name" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品描述" prop="description">
          <RichTextEditor 
            placeholder="请输入商品详情"
            v-model="goodsForm.description"
            :maxChars="maxContentLength"
            :editable="editable"
            @getContentLength="getContentLength" />
        </el-form-item>
        <el-form-item label="使用须知" prop="usageNote">
          <RichTextEditor
            placeholder="请输入商品使用须知"
            v-model="goodsForm.usageNote"
            :maxChars="maxContentLength"
            :editable="editable"
            @getContentLength="getContentLength" />
        </el-form-item>
        <el-form-item label="商品封面" prop="coverImg">
          <div class="cover-image">
            <div v-if="goodsForm.coverImg">
              <img class="cover-image-display" :src="goodsForm.coverImg | ossImageProcess" v-viewer>
              <el-button type="text" @click="goodsForm.coverImg = ''" icon="icon-remove-image" class="cover-image-remove-btn"></el-button>
            </div>
            <el-button v-else @click="handleCoverImageChange" icon="icon-add-image" class="cover-image-add-btn"></el-button>
          </div>
        </el-form-item>
        <el-form-item label="详情图片" prop="attachments">
          <el-col :span="24">
            <div class="attachment-image-list">
              <div v-for="(item, index) in goodsForm.attachments" v-bind:key="item">
                <img class="attachment-image-display" :src="item.attachmentUrl | ossImageProcess">
                <el-button type="text"
                  @click="goodsForm.attachments.splice(index, 1)"
                  icon="icon-remove-image"
                  class="attachment-image-remove-btn"></el-button>
              </div>
              <el-button v-if="goodsForm.attachments.length < 9"
                class="attachment-image-add-btn"
                icon="icon-add-image"
                @click="handleAttachmentImageChange"></el-button>
            </div>
          </el-col>
        </el-form-item>
        <el-form-item label="商品分类" prop="typeRelations">
          <el-col :span="15">
            <el-select placeholder="请选择商品分类" value-key="typeId" v-model="goodsForm.typeRelations" @change="$forceUpdate()" size="small" clearable filterable multiple>
              <el-option
                v-for="item in goodsTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="核销类型" prop="redeemType">
          <el-col :span="15">
            <el-select placeholder="请选择核销类型" v-model="goodsForm.redeemType" clearable size="small">
              <el-option
                v-for="item in redeemTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="积分值" prop="rewardValue">
          <el-col :span="15">
            <el-input-number controls-position="right" v-model="goodsForm.rewardValue" :min="0" :precision="0"></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="折扣价" prop="discount">
          <el-col :span="15">
            <el-input-number controls-position="right" v-model="goodsForm.discount" :min="0" :precision="0"></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="库存" prop="sku">
          <el-col :span="15">
            <el-input-number controls-position="right" v-model="goodsForm.sku" :min="0" :precision="0"></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="兑换限制" prop="exchangeLimit">
          <el-col :span="15">
            <el-input-number controls-position="right" v-model="goodsForm.exchangeLimit" :min="-1" :precision="0"></el-input-number>
            <span class="tips-info">【 -1 表示无兑换限制】</span>
          </el-col>
        </el-form-item>
        <el-form-item label="置顶级别" prop="sort">
          <el-col :span="15">
            <el-input-number controls-position="right" v-model="goodsForm.sort" :precision="0"></el-input-number>
            <span class="tips-info" >【 0 为默认不置顶，数字越大置顶优先级越高】</span>
          </el-col>
        </el-form-item>
        <el-form-item label="是否下架" prop="isBanned" v-if="isEdit">
          <el-col :span="15">
            <el-switch v-model="goodsForm.isBanned"></el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="下架原因" prop="banComment" v-if="isEdit && goodsForm.isBanned">
          <el-col :span="15">
            <el-input type="text" placeholder="请输入下架原因" v-model="goodsForm.banComment" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item class="operation">
          <el-col :span="15">
            <el-button size="medium" @click="$router.go(-1)">取消</el-button>
            <el-button v-if="!isEdit" size="medium" type="primary" @click="handleAdd(true)">保存</el-button>
            <el-button v-if="!isEdit" size="medium" type="primary" @click="handleAdd(false)">保存并上架</el-button>
            <el-button v-if="isEdit" size="medium" type="primary" @click="handleEdit">更新</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </basic-container>
  </div>
</template>

<script>
import RichTextEditor from '@/components/rich-text-editor/index.vue';
import { getGoods, saveGoods, updateGoodsById } from '@/api/mall/goods';
import { fetchGoodsTypeList } from '@/api/mall/type';
import { redeemTypeOptions } from '@/const/crud/mall/goods';

export default {
  data () {
    const validateBanComment = (rule, value, callback) => {
      if (this.isEdit && this.goodsForm.isBanned) {
        if (!value) {
          callback(new Error('请输入下架原因'));
        } else if (value.length > 500) {
          callback(new Error('长度不超过 500 个字符'));
        } else {   
          callback();  
        } 
      }
    };
    return {
      id: null,
      isEdit: false,
      maxContentLength: 20000,
      goodsForm: {
        name: '',
        description: '',
        usageNote: '',
        rewardValue: null,
        discount: null,
        coverImg: '',
        redeemType: null,
        sku: null,
        exchangeLimit: -1,
        sort: 0,
        isBanned: false,
        banComment: '',
        typeRelations: [],
        attachments: []
      },
      rules: {
        name: [
          { required: true, message: "请填写商品名称", trigger: 'blur' },
          { max: 40, message: '长度不超过 40 个字符', trigger: 'change' }
        ],
        coverImg: [
          { required: true, message: "请选择商品封面", trigger: 'change' },
        ],
        attachments: [
          { required: true, message: "至少选择一张详情图片", trigger: ['blur', 'change'] },
        ],
        rewardValue: [
          { required: true, message: "请填写积分值", trigger: 'blur' },
        ],
        discount: [
          { required: true, message: "请填写折扣价", trigger: 'blur' },
        ],        
        sku: [
          { required: true, message: "请填写库存", trigger: 'blur' },
        ],
        sort: [
          { required: true, message: "请填写置顶级别", trigger: 'blur' },
        ],
        redeemType: [
          { required: true, message: "请选择核销类型", trigger: 'change' },
        ],
        exchangeLimit: [
          { required: true, message: "请填写兑换限制", trigger: 'blur' },
        ],
        banComment: [
          { validator: validateBanComment, trigger: 'blur' }
        ],
      },
      redeemTypeOptions,
      goodsTypeOptions: [],
    }
  },
  components: {
    RichTextEditor,
  },
  async created () {
    await this.getGoodsTypeOptions();
    this.id = this.$route.params.id;
    if(this.id) {
      this.isEdit = true;
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      getGoods(this.id).then(res => {
        Object.assign(this.goodsForm, res.data.data);
        this.goodsForm.banComment = res.data.data.isBanned ? res.data.data.banComment : '';
        this.goodsForm.typeRelations = res.data.data.goodsTypes;
        delete this.goodsForm.goodsTypes;
      }).catch(err => {
        this.$message({
          message: err,
          type: '获取商品信息失败'
        })
        this.$router.go(-1);
      })
    },
    handleAdd(isBanned) {
      this.$refs.goodsForm.validate((valid) => {
        if (!valid) return;
        this.goodsForm.isBanned = isBanned;
        saveGoods(this.goodsForm).then(res => {
          this.$message({
            message: '新建商品成功',
            type: 'success'
          })
          this.$router.go(-1);
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    handleEdit() {
      this.$refs.goodsForm.validate((valid) => {
        if (!valid) return;
        if (!this.goodsForm.isBanned) {
          this.goodsForm.banComment = '';
        }
        updateGoodsById(this.goodsForm).then(res => {
          this.$message({
            message: '编辑商品成功',
            type: 'success'
          })
          this.$router.go(-1);
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    handleCoverImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.goodsForm.coverImg = list[0].contentUrl;
          this.$refs['goodsForm'].validateField('coverImg');
        }
      }, 1);
    },
    handleAttachmentImageChange() {
      this.$openMaterialLib((list) => {
        if (!list || list.length === 0) {
          return;
        }
        list.forEach(item => {
          if (this.goodsForm.attachments.length >= 9) {
            return;
          }
          this.goodsForm.attachments.push({
            attachmentUrl: item.contentUrl,
          })
        });
      }, 9 - this.goodsForm.attachments.length);
    },
    async getGoodsTypeOptions() {
      const response = await fetchGoodsTypeList();
      if (Array.isArray(response.data.data)) {
        const type = response.data.data.map(x => {
          return {
            value: {typeId: x.id},
            label: x.name
          }
        });
        this.goodsTypeOptions = type;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.goods-form {
  .tips-info {
    font-size: 12px;
    color: #7d7d7d;
    display: inline-block;
    margin-left:4px;
  }
  .cover-image {
    .cover-image-display {
      width: 80px;
      height: 80px;
    }
    .cover-image-remove-btn {
      position: absolute;
      padding: 0;
      margin-left: -15px;
    }
    .cover-image-add-btn {
      width: 80px;
      height: 80px;
      margin-left: 5px;
    }
  }
  .attachment-image-list {
    display: flex;
    .attachment-image-display {
      width: 80px;
      height: 80px;
      float: left;
      margin-left: 5px;
    }
    .attachment-image-remove-btn {
      position: absolute;
      padding: 0;
      margin-left: -15px;
    }
    .attachment-image-add-btn {
      width: 80px;
      height: 80px;
      margin-left: 5px;
    }
  }
  .operation {
    margin: 65px 0px 25px 0px;
    text-align: right!important;
  }
}
</style>